import { useState, useEffect } from "react";
import CommonIcon from "../../helpers/icons";
import {
  TextField,
  Avatar,
  Autocomplete,
  Paper,
  FormLabel,
  Switch,
  Button,
} from "@mui/material";
import { toast, ToastContainer } from "react-toastify";
import { TextareaAutosize, Tooltip } from "@material-ui/core";
import TeamsListView from "./Custom/TeamsListView";
import { Offcanvas } from "react-bootstrap";
import { Modal } from "react-bootstrap";
import Action from "../../../action/api";
import API from "../../helpers/endpointservice";
import CustomListView from "../MUIDataTable/CustomListView";

const EditTeamsPage = ({
  teamsData,
  closeEdit,
  currentData1,
  isWebMobile,
  activeUsers,
  getTeamsData,
  setloader,
}) => {
  let initialError = {
    teamName: false,
    owner: false,
  };

  const [currentData, setCurrentData] = useState(currentData1);
  const [teamError, setTeamError] = useState(initialError);
  const [currentEdit, setCurrentEdit] = useState({});
  const [showDetails, setShowDetails] = useState(true);
  const [showMembers, setShowMembers] = useState(false);
  const [editGroup, setEditGroup] = useState(false);
  const [addmembersOffcanvas, setAddMembersOffcanvas] = useState(false);
  const [filterScreen, setFilterScreen] = useState(false);
  const [detailsData, setDetailsData] = useState(null);
  const [detailsMobile, setDetailsMobile] = useState(true);
  const [openDialogUn, setOpenDialogUn] = useState(false);
  const [tableLoader, setTableLoader] = useState(false);
  const [assignedmembers, setAssignedMembers] = useState([]);
  const [unAssignedMembers, setUnAssignedMembers] = useState([]);
  const [memberAddData, setMemberAddData] = useState([]);
  const [memberAddError, setMemberAddError] = useState(false);
  const [memberDeleteModal, setMemberDeleteModal] = useState(false);
  const [memberDeleteData, setMemberDeleteData] = useState(null);
  const [pageSize, setPagesize] = useState(0);
  const [pageIndex, setPageIndex] = useState(10);
  const [columnFilters, setColumnFilters] = useState([]);
  const [sortingFilters, setsortingFilters] = useState([]);

  const [columns, setColumns] = useState([
    {
      accessorKey: "name",
      header: "Name",
    },
    {
      accessorKey: "email",
      header: "Email",
    },
    {
      accessorKey: "action",
      header: "Action",
      minSize: 50,
      maxSize: 50,
      enableColumnActions: false,
      enableSorting: false,
      enableColumnFilter: false,
      muiTableHeadCellProps: {
        sx: {
          borderTop: "1px solid rgba(224, 224, 224, 1)",
          "& .Mui-TableHeadCell-Content-Labels": {
            paddingLeft: "0px",
            fontWeight: "400",
          },
        },
      },
      Cell: ({ cell, row }) => {
        return (
          <span
            className="cursor-pointer"
            onClick={() =>
              handleDelete(row.original.userId, row.original.email)
            }
          >
            <CommonIcon fileName={"DeleteIcon"} />
          </span>
        );
      },
    },
  ]);

  useEffect(() => {
    if (currentEdit.teamId) {
      const team = teamsData.find((team) => team.teamId === currentEdit.teamId);
      if (team) {
        setCurrentEdit(team);
        setDetailsData(team);
      }
    }
  }, [teamsData]);

  const handleErrorChange = (type, value) => {
    setTeamError((prev) => ({
      ...prev,
      [type]: value,
    }));
  };

  const closeFilters = () => {
    setfilters((prev) => ({
      ...prev,
      name: "",
      email: "",
    }));
    setFilterScreen(false);
  };

  const handleMemberChange = (event, value) => {
    const formattedData = value.map((member) => ({
      userId: member.userId,
      email: member.email,
    }));
    setMemberAddData(formattedData);
  };

  const handleValidation = () => {
    let error = false;
    if (detailsData.teamName.trim() == "") {
      error = true;
      handleErrorChange("teamName", true);
    } else {
      handleErrorChange("teamName", false);
    }

    if (detailsData.ownerId?.trim() == "" || detailsData.ownerId == null) {
      error = true;
      handleErrorChange("owner", true);
    } else {
      handleErrorChange("owner", false);
    }

    return error;
  };

  const customToast = (message) => {
    toast(message, {
      hideProgressBar: true,
      autoClose: 2000, // Customize time as per your requirement
      closeOnClick: false,
      pauseOnHover: false,
      draggable: false,
      position: "top-right",
      className: "custom-toast", // Add a custom class here
    });
  };
  const handleTeamUpdate = () => {
    if (!handleValidation()) {
      setloader(true);
      let data = {
        teamName: detailsData.teamName,
        teamDescription: detailsData.description,
        ownerId: detailsData.ownerId,
      };
      Action.PUT(`${API.Teams}/${detailsData.teamId}`, data)
        .then((res) => {
          getTeamsData("");
          setEditGroup(false);
        })
        .catch((error) => {
          if (
            error?.response?.data?.message?.trim() ==
            "Team is already exists in this tenant"
          ) {
            customToast("Team already exists.");
          }
          setloader(false);
          console.log(error);
        });
    }
  };

  const handleDetailsChnage = (type, value) => {
    setDetailsData((prev) => ({
      ...prev,
      [type]: value,
    }));
  };
  const normalData = [];

  let initialFilter = {
    limit: 15,
    offset: 0,
    SortBy: "name",
    sortByOrder: "asc",
    name: "",
    email: "",
    pageNumber: 1,
    PageSize: 5,
  };
  const [filters, setfilters] = useState(initialFilter);
  const [isFilterApplied, setFilterApplied] = useState(false);
  const [filterOptions, setFilterOptions] = useState(initialFilter);

  const handleFilterchange = (type, value) => {
    setfilters((prev) => ({
      ...prev,
      [type]: value,
    }));
  };

  useEffect(() => {
    if (currentData) {
      setCurrentEdit(currentData);
      setDetailsData(currentData);
      setfilters(initialFilter);
      let data1 = {
        Name: initialFilter.name,
        Email: initialFilter.email,
        SortBy: initialFilter.SortBy,
        SortOrder: initialFilter.sortByOrder,
        PageNumber: 1,
      };
      if (!isWebMobile) {
        data1 = {
          ...data1,
          PageNumber: initialFilter.pageNumber,
          PageSize: initialFilter.PageSize,
        };
      }
      if (isWebMobile) {
        getAssignedMembersFilter(currentData.teamId, data1);
      }
      // getAssignedMembersFilter(currentData.teamId, data1);
      getUnAssignedMembers(currentData.teamId);
    }
  }, []);

  const handleDataFetch = (pagesize, pageindex, columnsfilters, sorting) => {
    setPagesize(pagesize);
    setPageIndex(pageindex);
    setColumnFilters(columnsfilters);
    setsortingFilters(sorting);

    // this.setState({ pageSize: pageSize, pageIndex: pageIndex, columnsFilters: columnsFilters, sortingFilters: sorting });

    const filterObject = columnsfilters.reduce((acc, curr) => {
      acc[curr.id] = curr.value;
      return acc;
    }, {});
    let sortorder = !sorting[0]?.desc;
    let data = {
      Name: filterObject.name ?? "",
      Email: filterObject.email ?? "",
      SortBy: sorting[0]?.id ?? "name",
      SortOrder: sortorder ? "asc" : "desc",
      PageNumber: pagesize + 1,
      PageSize: pageindex,
    };

    console.log(data);
    getAssignedMembersFilter(currentData.teamId, data);
  };

  const cancelDetailsEdit = () => {
    setDetailsData(currentEdit);
    setEditGroup(false);
    setTeamError(initialError);
  };

  useEffect(() => {
    if (!isWebMobile) {
      setDetailsMobile(false);
    }
  }, [isWebMobile]);

  const getAssignedMembers = (teamId) => {
    setfilters(initialFilter);
    setTableLoader(true);
    Action.GET(`${API.Teams}/${teamId}/assignedmembers`)
      .then((res) => {
        if (res.data) {
          setAssignedMembers(res.data);
        }
        setTableLoader(false);
      })
      .catch((error) => {
        console.log(error);
        setTableLoader(false);
      });
  };

  const getAssignedMembersFilter = (teamId, data) => {
    const params = new URLSearchParams();

    // Conditionally append parameters if they exist
    if (data) {
      if (data.Name) params.append("Name", data.Name);
      if (data.Email) params.append("Email", data.Email);
      if (data.SortBy) params.append("SortBy", data.SortBy);
      if (data.SortOrder) params.append("SortOrder", data.SortOrder);
      if (data.PageNumber) params.append("PageNumber", data.PageNumber);
      if (data.PageSize) params.append("PageSize", data.PageSize);
    }
    setTableLoader(true);
    Action.GET(
      `${API.Teams}/${teamId}/assignedmembers${
        params.toString() ? `?${params.toString()}` : ""
      }`
    )
      .then((res) => {
        if (res.data) {
          setAssignedMembers(res.data);
        }
        setTableLoader(false);
      })
      .catch((error) => {
        console.log(error);
        setTableLoader(false);
      });
  };

  const getUnAssignedMembers = (teamId) => {
    Action.GET(`${API.Teams}/${teamId}/unassignedmembers`)
      .then((res) => {
        if (res.data.data) {
          setUnAssignedMembers(res.data.data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const columngroupMemebers = [
    // { key: "members", label:"Members", width: "20%" },
    { key: "name", label: "Name", width: "30%" },
    { key: "email", label: "Email", width: "30%" },
    { key: "action", label: "Action", width: "20%" },
  ];

  const changeList = (data) => {
    setAddMembersOffcanvas(false);
    setMemberAddData([]);
    setMemberAddError(false);
    setCurrentData(data);
    setfilters(initialFilter);
    let data1 = {
      Name: initialFilter.name,
      Email: initialFilter.email,
      SortBy: initialFilter.SortBy,
      SortOrder: initialFilter.sortByOrder,
      PageNumber: 1,
    };
    if (!isWebMobile) {
      data1 = {
        ...data1,
        PageNumber: initialFilter.pageNumber,
        PageSize: initialFilter.PageSize,
      };
    }
    getUnAssignedMembers(data.teamId);
    setEditGroup(false);
    setCurrentEdit(data);
    setDetailsData(data);
    setShowDetails(true);
    // getAssignedMembersFilter(data.teamId, data1);
    setShowMembers(false);
  };

  const handleSort = (column) => {
    let sortByOrder = "asc";

    if (filters.sortByOrder == "asc") {
      sortByOrder = "desc";
    }

    setfilters((prev) => ({
      ...prev,
      sortByOrder: sortByOrder,
      SortBy: column.toLowerCase(),
    }));

    let data = {
      Name: filters.name,
      Email: filters.email,
      SortBy: column.toLowerCase(),
      SortOrder: sortByOrder,
      PageNumber: filters.pageNumber,
      PageSize: filters.PageSize,
    };
    getAssignedMembersFilter(currentEdit.teamId, data);
  };

  const handlePagination = (newPage) => {
    debugger;
    console.log("New Page:", newPage);
    setfilters((prev) => ({
      ...prev,
      pageNumber: newPage,
    }));
    let data = {
      Name: filters.name,
      Email: filters.email,
      SortBy: filters.SortBy,
      SortOrder: filters.sortByOrder,
      PageNumber: newPage,
      PageSize: filters.PageSize,
    };
    getAssignedMembersFilter(currentEdit.teamId, data);
  };

  const handlePagePerPage = (newPage) => {
    console.log("New Page:", newPage);
    setfilters((prev) => ({
      ...prev,
      PageSize: newPage,
      pageNumber: 1,
    }));
    let data = {
      Name: filters.name,
      Email: filters.email,
      SortBy: filters.SortBy,
      SortOrder: filters.sortByOrder,
      PageNumber: 1,
      PageSize: newPage,
    };
    getAssignedMembersFilter(currentEdit.teamId, data);
  };

  const handleDelete = (userId, email) => {
    let data = {
      userId: userId,
      email: email,
    };
    setMemberDeleteData(data);
    setMemberDeleteModal(true);
  };

  const handleClose = () => setOpenDialogUn(false);
  const handleShow = () => setOpenDialogUn(true);

  const noAction = () => {
    console.log("No clicked");
    handleClose();
  };

  const yesAction = () => {
    handleClose();
    setloader(true);
    Action.DELETE(`${API.Teams}/${currentEdit.teamId}`)
      .then((res) => {
        handleClose();
        closeEdit();
      })
      .catch((error) => {
        console.log(error);
        setloader(false);
      });
  };

  const handleAddMembers = () => {
    if (memberAddData.length == 0) {
      setMemberAddError(true);
    } else {
      setMemberAddError(false);
      setloader(true);
      let data = memberAddData;
      Action.POST(`${API.Teams}/${currentEdit.teamId}/member`, data)
        .then((res) => {
          setfilters(initialFilter);
          let data1 = {
            Name: initialFilter.name,
            Email: initialFilter.email,
            SortBy: initialFilter.SortBy,
            SortOrder: initialFilter.sortByOrder,
            PageNumber: 1,
          };
          if (!isWebMobile) {
            data1 = {
              ...data1,
              PageNumber: initialFilter.pageNumber,
              PageSize: initialFilter.PageSize,
            };
          }
          debugger;
          if (!isWebMobile) {
            handleDataFetch(pageSize, pageIndex, columnFilters, sortingFilters);
          } else {
            getAssignedMembersFilter(currentEdit.teamId, data1);
          }
          getUnAssignedMembers(currentEdit.teamId);
          setloader(false);
          setMemberAddData([]);
          setAddMembersOffcanvas(false);
          getTeamsData("");
          customToast("Members added successfully");
        })
        .catch((error) => {
          console.log(error);
          customToast("Error adding members");
          setloader(false);
        });
    }
  };

  const handleCloseMember = () => {
    setMemberDeleteModal(false);
    setMemberDeleteData(null);
  };

  const handleConfirmDelete = () => {
    handleCloseMember();
    setloader(true);
    let data = {
      ...memberDeleteData,
    };
    Action.DELETE(`${API.Teams}/${currentEdit.teamId}/member`, data)
      .then((res) => {
        setfilters(initialFilter);
        let data1 = {
          Name: initialFilter.name,
          Email: initialFilter.email,
          SortBy: initialFilter.SortBy,
          SortOrder: initialFilter.sortByOrder,
          PageNumber: 1,
        };
        if (!isWebMobile) {
          data1 = {
            ...data1,
            PageNumber: initialFilter.pageNumber,
            PageSize: initialFilter.PageSize,
          };
        }
        if (!isWebMobile) {
          handleDataFetch(pageSize, pageIndex, columnFilters, sortingFilters);
        } else {
          getAssignedMembersFilter(currentEdit.teamId, data1);
        }
        // getUnAssignedMembers(currentEdit.teamId);
        setMemberDeleteModal(false);
        getTeamsData("");
      })
      .catch((error) => {
        console.log(error);
        setloader(false);
      });
  };

  const ApplyFilters = () => {
    let data1;
    data1 = {
      Name: filters.name,
      Email: filters.email,
      SortBy: filters.SortBy,
      SortOrder: filters.sortByOrder,
      PageNumber: 1,
    };
    setFilterOptions(data1);
    if (filters.name || filters.email) {
      setFilterApplied(true);
    } else {
      setFilterApplied(false);
    }
    if (!isWebMobile) {
      data1 = {
        ...data1,
        PageNumber: filters.pageNumber,
        PageSize: filters.PageSize,
      };
    }
    getAssignedMembersFilter(currentEdit.teamId, data1);
    setFilterScreen(false);
  };
  const ApplyFiltersName = () => {
    let data1;
    data1 = {
      Name: "",
      Email: filters.email,
      SortBy: filters.SortBy,
      SortOrder: filters.sortByOrder,
      PageNumber: 1,
    };
    setFilterOptions(data1);
    if (filters.email) {
      setFilterApplied(true);
    } else {
      setFilterApplied(false);
    }
    setfilters((prev) => ({
      ...prev,
      name: "",
    }));
    if (!isWebMobile) {
      data1 = {
        ...data1,
        PageNumber: filters.pageNumber,
        PageSize: filters.PageSize,
      };
    }
    getAssignedMembersFilter(currentEdit.teamId, data1);
    setFilterScreen(false);
  };
  const ApplyFiltersEmail = () => {
    let data1;
    data1 = {
      Name: filters.name,
      Email: "",
      SortBy: filters.SortBy,
      SortOrder: filters.sortByOrder,
      PageNumber: 1,
    };
    setfilters((prev) => ({
      ...prev,
      email: "",
    }));
    setFilterOptions(data1);
    if (filters.name) {
      setFilterApplied(true);
    } else {
      setFilterApplied(false);
    }
    if (!isWebMobile) {
      data1 = {
        ...data1,
        PageNumber: filters.pageNumber,
        PageSize: filters.PageSize,
      };
    }
    getAssignedMembersFilter(currentEdit.teamId, data1);
    setFilterScreen(false);
  };

  const ResetFilters = () => {
    setfilters(initialFilter);
    let data1 = {
      Name: initialFilter.name,
      Email: initialFilter.email,
      SortBy: initialFilter.SortBy,
      SortOrder: initialFilter.sortByOrder,
      PageNumber: 1,
    };
    setFilterOptions(data1);
    if (!isWebMobile) {
      data1 = {
        ...data1,
        PageNumber: initialFilter.pageNumber,
        PageSize: initialFilter.PageSize,
      };
    }
    setFilterApplied(false);
    getAssignedMembersFilter(currentEdit.teamId, data1);
    setFilterScreen(false);
  };

  return (
    <>
      {/* <ToastContainer position="top-right" /> */}
      <Modal
        show={openDialogUn}
        onHide={handleClose}
        centered
        dialogClassName="modal-style"
        contentClassName="shadow-lg bg-white rounded"
        aria-labelledby="exampleModalLabel"
        id="deletemodal"
        style={{ zIndex: "1070" }}
      >
        <Modal.Body className="text-center">
          <CommonIcon fileName={"deletegroup"} />
          <br />
          <span>Are you sure, you want to delete this group?</span>
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <Button className="btn-no px-4" variant="primary" onClick={noAction}>
            No
          </Button>
          <Button
            className="btn-action px-4"
            variant="primary"
            onClick={yesAction}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={memberDeleteModal}
        onHide={handleCloseMember}
        centered
        dialogClassName="modal-style"
        contentClassName="shadow-lg bg-white rounded"
        aria-labelledby="exampleModalLabel"
        id="deletemodal"
        style={{ zIndex: "1070" }}
      >
        <Modal.Body className="text-center">
          <CommonIcon fileName="deletemember" />
          <br />
          <span>
            Are you sure, you want to delete this member from the team?
          </span>
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <Button
            className="btn-no px-4"
            variant="secondary"
            onClick={handleCloseMember}
          >
            No
          </Button>
          <Button
            className="btn-action px-4"
            variant="primary"
            onClick={handleConfirmDelete}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>

      {!isWebMobile && (
        <div className="d-flex align-items-start w-100">
          <div className="">
            <div className="leftsidepanel w-100">
              <div className="d-flex justify-content-between ps-3  pb-1 wholeheader12">
                <h3 className="headername1">Teams</h3>
              </div>
              <div className="leftpanel12 pb-1">
                <ul className="leftpanelulgroup">
                  {teamsData.map((e) => {
                    return (
                      <li
                        className={`${
                          currentEdit?.teamId == e.teamId
                            ? "leftpanelli"
                            : "leftpanelli1"
                        }`}
                        onClick={() => {
                          changeList(e);
                        }}
                      >
                        {e.teamName}
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
            <ul></ul>
          </div>
          <div className="d-flex align-items-start w-100">
            <div className="">
              <div className="d-flex justify-content-between ps-3 pb-1 wholeheader12">
                <Tooltip title={currentEdit?.teamName}>
                  <h3
                    className={`${
                      currentEdit?.teamName?.length < 20
                        ? "headername1"
                        : "lowerheadername"
                    }`}
                    style={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      width: "200px", // Adjust the width as needed
                    }}
                  >
                    <span>{currentEdit?.teamName}</span>
                  </h3>
                </Tooltip>
              </div>
              <div className="leftpanel12 pb-1">
                <ul className="leftpanelulgroup">
                  <li
                    className={`d-flex align-items-center  ${
                      showDetails ? "leftpanelli" : "leftpanelli1"
                    }`}
                    onClick={() => {
                      setShowDetails(true);
                      setShowMembers(false);
                      cancelDetailsEdit();
                      setAddMembersOffcanvas(false);
                      setMemberAddData([]);
                      setMemberAddError(false);
                    }}
                  >
                    <CommonIcon fileName={"idcardicon"} />
                    &nbsp;&nbsp;Details
                  </li>
                  <li
                    className={`d-flex align-items-center ${
                      showMembers ? "leftpanelli" : "leftpanelli1"
                    }`}
                    onClick={() => {
                      setShowDetails(false);
                      setShowMembers(true);
                    }}
                  >
                    <CommonIcon fileName={"groupicon"} />
                    &nbsp;&nbsp;Members
                  </li>
                  {/* <li className={`${this.state.showsroles ? "leftpanelli" : "leftpanelli1"}`} onClick={this.roles}><CommonIcon fileName={'settingicon'} />&nbsp;&nbsp;Assignments</li> */}
                </ul>
              </div>
            </div>
            <div className="w-100">
              {showMembers && (
                <div className="w-100 height100 p-3 pt-1">
                  <div className="d-flex justify-content-between ps-1 pt-1  pb-1">
                    <h3 className="headername1 pt-1">Members</h3>
                    <div className="d-flex justify-content-end pb-2 pe-1 pt-2">
                      <button
                        className="btn-fun btn-new fs-7 me-2"
                        onClick={() => {
                          setAddMembersOffcanvas(true);
                        }}
                      >
                        <CommonIcon fileName={"AddPlus"} />
                        Add
                      </button>
                      {/* <button className='btn-fun fs-7 ps-3 pe-3 me-3' onClick={() => { setFilterScreen(true); }} ><CommonIcon fileName={'Filter'} /></button> */}
                      <button
                        data-bs-dismiss="offcanvas"
                        className="offcavasclose float-end mt--10 pe-0"
                        onClick={closeEdit}
                      >
                        <CommonIcon fileName={"Close"} />
                      </button>
                    </div>
                  </div>

                  <div className="ps-2 pe-1" style={{ width: "100%" }}>
                    {/* <TeamsListView
                                            // scrollRef={tableRef}
                                            // handleScroll={this.handleScroll}
                                            columns={columngroupMemebers}
                                            data={[]}
                                            value={assignedmembers.data ?? []}
                                            handleSort={handleSort}
                                            sortConfig={filters}
                                            handledeletemember={handleDelete}
                                            isLoader={tableLoader}
                                            paginatedData={handlePagination}
                                            rowPerPage={handlePagePerPage}
                                            pagesize={filters.PageSize}
                                            pagenumber={filters.pageNumber}
                                            totalcount={assignedmembers?.pagination.totalcount}
                                            totalpages={assignedmembers?.pagination?.totalPages}
                                            currentPage={assignedmembers?.pagination?.currentPage}
                                        /> */}
                    <CustomListView
                      listData={assignedmembers.data ?? []}
                      columns={columns}
                      handleDataFetch={handleDataFetch}
                      totalCount={assignedmembers?.pagination?.totalCount ?? 0}
                      isLoading={tableLoader}
                    />
                  </div>
                </div>
              )}
              {showDetails && (
                <div className="">
                  <div className="d-flex justify-content-between ps-3 pe-4 pb-1 pt-2">
                    <h3 className="headername1">Details</h3>
                    <button
                      data-bs-dismiss="offcanvas"
                      className="offcavasclose float-end "
                      onClick={closeEdit}
                    >
                      <CommonIcon fileName={"Close"} />
                    </button>
                  </div>

                  <div className="row p-4 pt-1">
                    <div className="row p-4  ps-3 pt-2 pe-0 ">
                      <div className="col-3 ps-2">
                        <h3 className="licenseheader">Team details</h3>
                      </div>
                      <div
                        className={`col-9 scrollEdit ${
                          !editGroup ? "pe-0" : "pe-2"
                        }`}
                      >
                        <div className="col-12 d-flex ">
                          <div className={editGroup ? "col-12" : "col-10"}>
                            <div className="d-flex">
                              <FormLabel className="formlabel-style1">
                                Team Name{" "}
                              </FormLabel>{" "}
                              {!editGroup ? (
                                <>
                                  <span className="px-3">-</span>{" "}
                                  <span className={`formlabel-input`}>
                                    {currentEdit?.teamName}
                                  </span>
                                </>
                              ) : (
                                ""
                              )}
                            </div>
                            {editGroup ? (
                              <>
                                {" "}
                                <TextField
                                  id="email"
                                  inputProps={{ maxLength: 255 }}
                                  error={teamError.teamName}
                                  helperText={
                                    teamError.teamName
                                      ? "Team name is missing"
                                      : ""
                                  }
                                  className={`filter_input br-4 }`}
                                  fullWidth
                                  onChange={(e) => {
                                    handleDetailsChnage(
                                      "teamName",
                                      e.target.value
                                    );
                                  }}
                                  value={detailsData?.teamName}
                                  variant="filled"
                                  focused
                                />
                              </>
                            ) : (
                              ""
                            )}
                          </div>
                          {/* {!editGroup && (
                            <div className="col-2 pe-1">
                              {!editGroup ? (
                                <span
                                  className="isedit cursor-pointer float-end "
                                  onClick={() => {
                                    setEditGroup(true);
                                  }}
                                >
                                  <CommonIcon fileName={"editicon"} />
                                </span>
                              ) : (
                                ""
                              )}
                            </div>
                          )} */}
                        </div>
                        <div className="col-12 mt-3">
                          <div className="d-flex">
                            <FormLabel className="formlabel-style1">
                              Total members{" "}
                            </FormLabel>
                            <span className={`formlabel-input `}>
                              <span className="px-3">-</span>
                              {currentEdit?.totalMembers}
                            </span>
                          </div>
                        </div>
                        <div className="col-12 mt-3">
                          <div className="d-flex align-items-start">
                            <FormLabel className="formlabel-style1">
                              Owner{" "}
                            </FormLabel>
                            {!editGroup ? (
                              <>
                                <div className="">
                                  <span className="px-3">-</span>
                                </div>{" "}
                                <span className={`formlabel-input `}>
                                  {currentEdit?.ownerName}
                                </span>{" "}
                              </>
                            ) : (
                              ""
                            )}
                          </div>
                          {editGroup ? (
                            <Autocomplete
                              options={activeUsers}
                              className="OwnerSelect"
                              onChange={(e, value) => {
                                handleDetailsChnage("ownerId", value?.userId);
                              }}
                              value={
                                activeUsers.find(
                                  (user) => user.userId === detailsData.ownerId
                                ) || null
                              }
                              error={teamError.owner}
                              getOptionLabel={(option) => `${option.email}`}
                              renderOption={(props, option) => (
                                <li
                                  {...props}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    fontSize: "12px",
                                  }}
                                >
                                  <Avatar
                                    sx={{
                                      width: 35,
                                      height: 35,
                                      marginRight: 2,
                                    }}
                                  >
                                    {option.userName.charAt(0)}
                                  </Avatar>
                                  <div>
                                    <strong>{option.userName}</strong>
                                    <div>{option.email}</div>
                                  </div>
                                </li>
                              )}
                              renderInput={(params) => (
                                <div className="d-flex">
                                  <TextField
                                    error={teamError.owner}
                                    helperText={
                                      teamError.owner
                                        ? "Select owner for team"
                                        : ""
                                    }
                                    id="email"
                                    className={`filter_input br-4 OwnerSelect`}
                                    variant="filled"
                                    fullWidth
                                    focused
                                    {...params}
                                    InputProps={{
                                      ...params.InputProps,
                                      endAdornment: null, // Removes the dropdown arrow
                                      sx: {
                                        height: "max-content",
                                        "& .MuiAutocomplete-popupIndicator": {
                                          display: "none", // Ensure any popup indicator is hidden
                                        },
                                      },
                                      inputProps: {
                                        ...params.inputProps,
                                        style: {
                                          paddingTop: "10.5px",
                                          paddingBottom: "10.5px",
                                          display: "flex",
                                        },
                                      },
                                    }}
                                  />
                                </div>
                              )}
                              sx={{ width: "100%", marginRight: 2 }}
                            />
                          ) : (
                            ""
                          )}
                        </div>
                        <div className="col-12 mt-3">
                          {/* <div className='d-flex align-items-start'><FormLabel className="formlabel-style1">Description   </FormLabel>{!editGroup ? <><div className=''><span className="px-3">-</span></div> <span className={`formlabel-input `}>{currentEdit?.description}</span> </> : ""}</div> */}
                          <div className="d-flex align-items-start">
                            <FormLabel className="formlabel-style1">
                              Description{" "}
                            </FormLabel>
                          </div>
                          {!editGroup ? (
                            <>
                              {" "}
                              <span
                                className={`formlabel-input mt-1`}
                                style={{ textAlign: "justify" }}
                              >
                                {currentEdit?.description}
                              </span>{" "}
                            </>
                          ) : (
                            ""
                          )}
                          {editGroup ? (
                            <TextareaAutosize
                              fullWidth
                              id="descriptionteams"
                              className={`filter_input br-4 }`}
                              onChange={(e) => {
                                handleDetailsChnage(
                                  "description",
                                  e.target.value
                                );
                              }}
                              value={detailsData?.description}
                              variant="filled"
                              focused
                              minRows={5}
                              style={{ paddingLeft: "13px" }}
                            />
                          ) : (
                            ""
                          )}
                        </div>

                        {!editGroup ? (
                          <div className="col-4 mb-3 mt-3">
                            <span
                              className="editButton cursor-pointer ps-3 pe-3 me-2"
                              onClick={() => {
                                setEditGroup(true);
                              }}
                            >
                              Edit
                            </span>
                            <span
                              className="unsubscribe cursor-pointer ps-3 pe-3"
                              onClick={() => {
                                handleShow();
                              }}
                            >
                              Delete
                            </span>
                          </div>
                        ) : (
                          ""
                        )}
                        {editGroup ? (
                          <div className="col-12 pb-20 pr-28 mt-2">
                            <button
                              className={`btn-fun btn-action btn-filter-action`}
                              variansetFilterScreent="primary"
                              onClick={() => {
                                handleTeamUpdate();
                              }}
                            >
                              Save
                            </button>
                            <button
                              className={`btn-cancel btn-filter-action border-none`}
                              onClick={() => {
                                cancelDetailsEdit();
                              }}
                              variant="outlined"
                            >
                              Cancel
                            </button>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
      {isWebMobile && detailsMobile && (
        <div className="leftsidepanelattrmobile">
          <div className="d-flex justify-content-between ps-3 pe-2 pb-1 wholeheader1">
            <Tooltip title={currentEdit?.teamName}>
            <h3
              className={`${
                currentEdit?.teamName?.length < 20
                  ? "headername1"
                  : "lowerheadername"
              }`}
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                width: "200px", // Adjust the width as needed
              }}
            >
              
                <span>{currentEdit?.teamName}</span>
              
            </h3></Tooltip>
            <button
              data-bs-dismiss="offcanvas"
              className="offcavasclose float-end mt--10"
              onClick={() => {
                closeEdit();
              }}
            >
              <CommonIcon fileName={"Close"} />
            </button>
          </div>
          <div className="leftpanel1 pb-1">
            <ul className="leftpanelulgroup">
              <li
                className={`d-flex align-items-center ${
                  showDetails ? "leftpanelli " : "leftpanelli1"
                }`}
                onClick={() => {
                  setShowDetails(true);
                  setShowMembers(false);
                  setDetailsMobile(false);
                  cancelDetailsEdit();
                  setAddMembersOffcanvas(false);
                  setMemberAddData([]);
                  setMemberAddError(false);
                }}
              >
                <CommonIcon fileName={"idcardicon"} />
                &nbsp;&nbsp;Details
              </li>
              <li
                className={`d-flex align-items-center ${
                  showMembers ? "leftpanelli" : "leftpanelli1"
                }`}
                onClick={() => {
                  setShowDetails(false);
                  setShowMembers(true);
                  setDetailsMobile(false);
                }}
              >
                <CommonIcon fileName={"groupicon"} />
                &nbsp;&nbsp;Members
              </li>
              {/* <li className={`${this.state.showsroles ? "leftpanelli" : "leftpanelli1"}`} onClick={this.roles}><CommonIcon fileName={'settingicon'} />&nbsp;&nbsp;Assignments</li> */}
            </ul>
          </div>
        </div>
      )}

      {isWebMobile && !detailsMobile && (
        <div className="w-100">
          {showMembers && (
            <div className="w-100 p-3 pt-1">
              <div className="d-flex justify-content-between ps-1 pt-1  pb-1">
                <h3 className="headername1 pt-1">Members</h3>
                <div className="d-flex justify-content-end pb-2 pe-1 pt-2">
                  <button
                    className="btn-fun btn-new fs-7 me-2"
                    onClick={() => {
                      setAddMembersOffcanvas(true);
                    }}
                  >
                    <CommonIcon fileName={"AddPlus"} />
                    Add
                  </button>
                  <button
                    className="btn-fun fs-7 ps-3 pe-3 me-3"
                    onClick={() => {
                      setFilterScreen(true);
                    }}
                  >
                    <CommonIcon
                      fileName={isFilterApplied ? "Filtered" : "Filter"}
                    />
                  </button>
                  <button
                    data-bs-dismiss="offcanvas"
                    className="offcavasclose float-end mt--10"
                    onClick={() => {
                      setDetailsMobile(true);
                    }}
                  >
                    <CommonIcon fileName={"Close"} />
                  </button>
                </div>
              </div>
              {isFilterApplied && (
                <>
                  <div
                    className="mt-3 ms-2 mb-0"
                    style={{ paddingRight: "2rem" }}
                  >
                    {filterOptions?.Name !== "" &&
                      filterOptions?.Name !== null && (
                        <span className="filteredBadge">
                          <span>Name</span>
                          <span onClick={ApplyFiltersName} className="ms-2">
                            <CommonIcon fileName={"CloseSmallwhite"} />
                          </span>
                        </span>
                      )}
                    {filterOptions?.Email !== "" &&
                      filterOptions?.Email !== null && (
                        <span className="filteredBadge">
                          <span>Email</span>
                          <span onClick={ApplyFiltersEmail} className="ms-2">
                            <CommonIcon fileName={"CloseSmallwhite"} />
                          </span>
                        </span>
                      )}
                  </div>
                  <p className="ms-2 mb-0 mt-2 countValue">
                    Count: {assignedmembers.data.length}
                  </p>
                </>
              )}
              <div className="row ps-4 pe-1 mt-2 overflowgroupmembers">
                {assignedmembers?.data?.map((element) => {
                  console.log(element);

                  return (
                    <div
                      className="card sharpcorner  cursor-pointer px-3 my-2 mt-2 "
                      style={{ width: "94%" }}
                    >
                      <div className="card-body pt-0 pb-0">
                        <div
                          style={{
                            position: "absolute",
                            left: "0",
                            top: "-0.1px",
                            bottom: "-0.2px",
                            width: "4px",
                            backgroundColor: " rgb(33, 150, 243)",
                          }}
                        ></div>
                        <div className="row">
                          <div className="col-12 d-flex align-items-center mb-1">
                            <div className="row">
                              <div className="col-12">
                                <span
                                  className="reporttext14"
                                  style={{ fontWeight: "bold" }}
                                >
                                  {element.name}
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="col-6 d-flex align-items-center">
                            <div className="row ">
                              <div className="col-12">
                                <span className="reporttext14">Email</span>
                              </div>
                              <div className="col-12">
                                <span className="reporttext12">
                                  {element.email}
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="col-6 d-flex align-items-center justify-content-end ">
                            <span
                              className="float-end"
                              onClick={() => {
                                handleDelete(element.userId, element.email);
                              }}
                            >
                              <CommonIcon fileName={"DeleteIcon"} />
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
          {showDetails && (
            <div className="">
              <div className="d-flex justify-content-between ps-2 pe-3 pb-1 pt-2">
                <h3 className="headername1">Details</h3>
                <button
                  data-bs-dismiss="offcanvas"
                  className="offcavasclose float-end "
                  onClick={() => {
                    setDetailsMobile(true);
                  }}
                >
                  <CommonIcon fileName={"Close"} />
                </button>
              </div>

              <div className="row p-4 pt-1">
                <div className="row p-4  ps-1 pt-2 pe-0 ">
                  <div
                    className={`col-12 scrollEdit ${
                      !editGroup ? "pe-0" : "pe-2"
                    }`}
                  >
                    <div className="col-12 d-flex ">
                      <div className={editGroup ? "col-12" : "col-10"}>
                        <div className="d-flex">
                          <FormLabel className="formlabel-style1">
                            Team Name{" "}
                          </FormLabel>
                        </div>
                        {editGroup ? (
                          <>
                            {" "}
                            <TextField
                              id="email"
                              error={teamError.teamName}
                              helperText={
                                teamError.teamName ? "Team name is missing" : ""
                              }
                              inputProps={{ maxLength: 255 }}
                              className={`filter_input br-4 }`}
                              fullWidth
                              onChange={(e) => {
                                handleDetailsChnage("teamName", e.target.value);
                              }}
                              value={detailsData?.teamName}
                              variant="filled"
                              focused
                            />
                          </>
                        ) : (
                          ""
                        )}
                      </div>
                      {/* {!editGroup && (
                        <div className="col-2 pe-1">
                          {!editGroup ? (
                            <span
                              className="isedit cursor-pointer float-end "
                              onClick={() => {
                                setEditGroup(true);
                              }}
                            >
                              <CommonIcon fileName={"editicon"} />
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                      )} */}
                    </div>
                    {!editGroup && (
                      <div className="col-12">
                        <span className={`formlabel-input`}>
                          {currentEdit?.teamName}
                        </span>
                      </div>
                    )}
                    <div className="col-12 mt-3">
                      <div className="d-flex">
                        <FormLabel className="formlabel-style1">
                          Total members{" "}
                        </FormLabel>
                      </div>
                    </div>
                    {!editGroup && (
                      <div className="col-12">
                        <span className={`formlabel-input `}>
                          {currentEdit?.totalMembers}
                        </span>
                      </div>
                    )}
                    <div className="col-12 mt-3">
                      <div className="d-flex align-items-start">
                        <FormLabel className="formlabel-style1">
                          Owner{" "}
                        </FormLabel>
                      </div>
                      {editGroup ? (
                        <Autocomplete
                          options={activeUsers}
                          onChange={(e, value) => {
                            handleDetailsChnage("ownerId", value?.userId);
                          }}
                          value={
                            activeUsers.find(
                              (user) => user.userId === detailsData.ownerId
                            ) || null
                          }
                          error={teamError.owner}
                          getOptionLabel={(option) => `${option.email}`}
                          renderOption={(props, option) => (
                            <li
                              {...props}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                fontSize: "12px",
                              }}
                            >
                              <Avatar
                                sx={{ width: 35, height: 35, marginRight: 2 }}
                              >
                                {option.userName.charAt(0)}
                              </Avatar>
                              <div>
                                <strong>{option.userName}</strong>
                                <div>{option.email}</div>
                              </div>
                            </li>
                          )}
                          renderInput={(params) => (
                            <div className="d-flex">
                              <TextField
                                error={teamError.owner}
                                helperText={
                                  teamError.owner ? "Select owner for team" : ""
                                }
                                id="email"
                                className={`filter_input br-4 }`}
                                variant="filled"
                                fullWidth
                                focused
                                {...params}
                                InputProps={{
                                  ...params.InputProps,
                                  endAdornment: null, // Removes the dropdown arrow
                                  sx: {
                                    height: "max-content",
                                    "& .MuiAutocomplete-popupIndicator": {
                                      display: "none", // Ensure any popup indicator is hidden
                                    },
                                  },
                                  inputProps: {
                                    ...params.inputProps,
                                    style: {
                                      paddingTop: "10.5px",
                                      paddingBottom: "10.5px",
                                      display: "flex",
                                    },
                                  },
                                }}
                              />
                            </div>
                          )}
                          sx={{ width: "100%", marginRight: 2 }}
                        />
                      ) : (
                        ""
                      )}
                    </div>
                    {!editGroup && (
                      <div className="col-12">
                        <span className={`formlabel-input `}>
                          {currentEdit?.ownerName}
                        </span>
                      </div>
                    )}
                    <div className="col-12 mt-3">
                      <div className="d-flex align-items-start">
                        <FormLabel className="formlabel-style1">
                          Description{" "}
                        </FormLabel>
                      </div>
                      {editGroup ? (
                        <TextareaAutosize
                          fullWidth
                          id="descriptionteams"
                          className={`filter_input br-4 }`}
                          onChange={(e) => {
                            handleDetailsChnage("description", e.target.value);
                          }}
                          value={detailsData?.description}
                          variant="filled"
                          focused
                          minRows={5}
                          style={{ paddingLeft: "13px" }}
                        />
                      ) : (
                        ""
                      )}
                    </div>
                    {!editGroup && (
                      <div className="col-12">
                        <span className={`formlabel-input `}>
                          {currentEdit?.description}
                        </span>
                      </div>
                    )}

                    {!editGroup ? (
                      <div className="col-4 mb-3 mt-3">
                        <span
                          className="editButton cursor-pointer ps-3 pe-3 me-2"
                          onClick={() => {
                            setEditGroup(true);
                          }}
                        >
                          Edit
                        </span>
                        <span
                          className="unsubscribe cursor-pointer ps-3 pe-3"
                          onClick={() => {
                            handleShow();
                          }}
                        >
                          Delete
                        </span>
                      </div>
                    ) : (
                      ""
                    )}
                    {editGroup ? (
                      <div className="col-12 pb-20 pr-28 mt-2">
                        <button
                          className={`btn-fun btn-action btn-filter-action`}
                          variant="primary"
                          onClick={() => {
                            handleTeamUpdate();
                          }}
                        >
                          Save
                        </button>
                        <button
                          className={`btn-cancel btn-filter-action border-none`}
                          onClick={() => {
                            cancelDetailsEdit();
                          }}
                          variant="outlined"
                        >
                          Cancel
                        </button>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      )}

      <Offcanvas
        show={addmembersOffcanvas}
        placement="end"
        scroll={false}
        backdrop={true}
        id="AddGroupmain"
        onHide={() => {
          setAddMembersOffcanvas(false);
          setMemberAddData([]);
          setMemberAddError(false);
        }}
      >
        <div className={`offcanvas-header px-4  pb-2`}>
          <span className="headername1  ">Add Members</span>
          <button
            data-bs-dismiss="offcanvas"
            className="offcavasclose pe-3"
            onClick={() => {
              setAddMembersOffcanvas(false);
              setMemberAddData([]);
              setMemberAddError(false);
            }}
          >
            <CommonIcon fileName={"Close"} />
          </button>
        </div>

        <div className="offcanvas-body pt-3" style={{ overflow: "hidden" }}>
          <div className="row" style={{ padding: "0rem 1rem" }}>
            <div className="col-12  flex-1">
              <div className="d-flex align-items-center justify-content-start col-lg-12 col-md-12 col-sm-12 pt-0 p-1 ps-0">
                <Autocomplete
                  className="col-12"
                  multiple
                  options={unAssignedMembers ?? []}
                  value={
                    memberAddData.length === 0
                      ? []
                      : unAssignedMembers.filter((member) =>
                          memberAddData.some(
                            (selected) => selected.userId === member.userId
                          )
                        )
                  }
                  onChange={handleMemberChange}
                  getOptionLabel={(option) => `${option.email}`}
                  renderOption={(props, option) => (
                    <li
                      {...props}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        fontSize: "12px",
                      }}
                    >
                      <Avatar sx={{ width: 35, height: 35, marginRight: 2 }}>
                        {option.name.charAt(0)}
                      </Avatar>
                      <div>
                        <strong>{option.name}</strong>
                        <div>{option.email}</div>
                      </div>
                    </li>
                  )}
                  renderInput={(params) => (
                    <div className="d-flex">
                      <TextField
                        error={memberAddError}
                        helperText={
                          memberAddError ? "Select members to add" : ""
                        }
                        className="addadmininput"
                        {...params}
                        variant="filled"
                        sx={{
                          width: "100%",
                          "& .MuiInputBase-root": {
                            padding: "10px !important", // ✅ Reset padding for the entire input
                          },
                          "& .MuiInputBase-input": {
                            padding: "8px !important", // ✅ Default padding for the input text
                          },
                          "& .MuiAutocomplete-tag": {
                            padding: "3px 6px !important", // ✅ Reset padding for selected tags
                            margin: "2px !important",
                          },
                          "& .MuiFormControl-root": {
                            padding: "0 !important", // ✅ Reset padding for the form control wrapper
                          },
                          "& .MuiFilledInput-root": {
                            paddingTop: "5px !important",
                            paddingBottom: "5px !important",
                          },
                        }}
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: null, // Keeps dropdown arrow hidden
                        }}
                      />
                    </div>
                  )}
                  sx={{ width: "100%", marginRight: 2 }}
                />
              </div>
            </div>
          </div>
          <p class="ml-12" />
          <div className="row mt-2">
            <div className="col-12 pb-20 pr-28 ml-19 ps-2">
              <button
                className="btn-fun btn-new fs-7 ps-4 pe-4"
                onClick={() => {
                  handleAddMembers();
                }}
              >
                Add
              </button>
              &nbsp;&nbsp;
            </div>
          </div>

          <div>
            <div className={`col-12 `}></div>
          </div>
        </div>
      </Offcanvas>

      <Offcanvas
        show={filterScreen}
        placement="end"
        scroll={false}
        backdrop={true}
        id="FilterScreenroles"
        onHide={() => {
          closeFilters();
        }}
      >
        <div className={`offcanvas-header ps-4 pe-4  pt-4 pb-3 mt-10`}>
          <h6
            id="offcanvasRightLabel"
            className="modal-title head-span"
            style={{ fontWeight: "600" }}
          >
            Filters
          </h6>
          <button
            className="offcavasclose"
            onClick={() => {
              closeFilters();
            }}
          >
            <CommonIcon fileName={"Close"} />
          </button>
        </div>

        <div className="offcanvas-body ps-4  pt-0">
          <div className="row">
            <div
              className="row ps-3"
              style={{ padding: "0px", paddingTop: "0" }}
            >
              <div className={`col-12 mt-2`}>
                <TextField
                  id="jobOpTitle"
                  className="filter_input"
                  fullWidth
                  label="Name"
                  variant="filled"
                  value={filters.name}
                  onChange={(e) => {
                    handleFilterchange("name", e.target.value);
                  }}
                  // value={this.state.choice.name}
                  // onChange={(e) =>
                  //     this.lookupChange(e, "", "name")
                  // }
                  focused
                />
              </div>
              <div className={`col-12 mt-2`}>
                <TextField
                  id="jobOpTitle"
                  className="filter_input"
                  fullWidth
                  label="Email"
                  variant="filled"
                  value={filters.email}
                  onChange={(e) => {
                    handleFilterchange("email", e.target.value);
                  }}
                  // value={this.state.choice.email}
                  // onChange={(e) =>
                  //     this.lookupChange(e, "", "email")
                  // }
                  focused
                />
              </div>
            </div>
          </div>
        </div>
        <div className="row pe-2">
          <div className="col-12 align_justify_end pb-20 pe-4">
            <Button
              className="btn-clear mr-10 border-none"
              variant="outlined"
              // onClick={() => this.clearRoleFilter()}
              sx={{
                borderRadius: 0,
                textTransform: "none",
                textTransform: "none", // This will prevent the text from being transformed to uppercase
                "&:hover": {
                  borderRadius: 0,
                },
              }}
              onClick={() => {
                ResetFilters();
              }}
            >
              Reset
            </Button>
            <button
              className="btn-apply"
              variant="primary"
              onClick={() => {
                ApplyFilters();
              }}
            >
              Apply
            </button>
          </div>
        </div>
      </Offcanvas>
    </>
  );
};

export default EditTeamsPage;
